import { DonutChart } from '@/design-system/components/charts';
import { DonutChartLegend } from '@/design-system/components/charts/donutChart/DonutChartLegend';
import { useDonutChart } from '@/design-system/components/charts/donutChart/useDonutChart.hook';
import { SxProp, View } from 'dripsy';
import { useMemo, useState } from 'react';
import { useStore } from 'store/store';
import { OverviewProps } from './Overview';

export interface OverviewNativeProps extends OverviewProps {}

export const OverviewNative: React.FC<OverviewNativeProps> = ({ data, netAssetValue, currency, lastUpdated, onChangeCurrency }) => {
  const store = useStore();
  const [containerWidth, setContainerWidth] = useState(0);
  const radius = useMemo(() => {
    return containerWidth / 2 - 40;
  }, [containerWidth]);

  const { chartData, legendData, selectArc } = useDonutChart({
    data,
    radius,
    legendValueSuffix: currency
  });

  return (
    <View
      sx={styles.container}
      onLayout={(event) => {
        setContainerWidth(event.nativeEvent.layout.width);
      }}>
      <DonutChart sx={styles.donutChart} donutChartData={chartData} radius={radius < 0 ? 0 : radius} />
      <DonutChartLegend legendData={legendData} selectArc={selectArc} showValue={store.showAmount} />
    </View>
  );
};

enum StyleName {
  container = 'container',
  donutChart = 'donutChart'
}

const styles: Record<StyleName, SxProp> = {
  container: { flex: 1, paddingX: '$4', paddingY: '$5', gap: '$7' },
  donutChart: { margin: 'auto' }
};
